function rvGetProducts() {
  try {
    return JSON.parse(localStorage.getItem('recently_viewed_products')) || [];
  } catch (e) {
    return [];
  }
}

function rvGetTitle() {
  const lang = document.documentElement.lang || 'en';
  if (lang.startsWith('de')) return 'Zuletzt angesehen';
  if (lang.startsWith('es')) return 'Visto recientemente';
  return 'Recently Viewed';
}

function rvGetActiveSearchInput() {
  const inputs = document.querySelectorAll('input[type="search"][name="q"], input[data-js-search-input]');

  for (const input of inputs) {
    if (input.offsetParent !== null) return input;
  }

  return null;
}

function rvGetSearchPanel(input) {
  const overlayId = input.getAttribute('data-js-focus-overlay');
  const type = overlayId && overlayId.includes('mobile') ? 'mobile' : 'desktop';

  return document.querySelector(`[data-rv-search-panel="${type}"]`);
}

function rvRenderInSearch() {
  const input = rvGetActiveSearchInput();
  if (!input) return;

  const panel = rvGetSearchPanel(input);
  if (!panel) return;

  const hasKeyword = input.value.trim().length > 0;

  if (hasKeyword) {
    panel.innerHTML = '';
    panel.classList.add('is-hidden');
    return;
  }

  const viewed = rvGetProducts();

  if (!viewed.length) {
    panel.innerHTML = '';
    panel.classList.add('is-hidden');
    return;
  }

  panel.classList.remove('is-hidden');

  const limit = window.innerWidth <= 768 ? 4 : 5;

  panel.innerHTML = `
    <div class="rv-search-panel">
      <div class="rv-search-title">${rvGetTitle()}</div>
      <div class="rv-search-list">
        ${viewed.slice(0, limit).map(product => {
          const image = product.image || product.featured_image || '';

          return `
            <a href="${product.url || '#'}" class="rv-search-item">
              ${image ? `<img src="${image}" alt="${product.title || ''}" loading="lazy">` : ''}
              <div class="rv-search-name">${product.title || ''}</div>
            </a>
          `;
        }).join('')}
      </div>
    </div>
  `;
}

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('focusin', function (e) {
    if (
      e.target.matches('input[type="search"][name="q"]') ||
      e.target.matches('input[data-js-search-input]')
    ) {
      setTimeout(rvRenderInSearch, 100);
      setTimeout(rvRenderInSearch, 300);
    }
  });

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.site-search-handle') ||
      e.target.closest('input[type="search"]') ||
      e.target.closest('[data-js-search-input]')
    ) {
      setTimeout(rvRenderInSearch, 100);
      setTimeout(rvRenderInSearch, 300);
    }
  });

  document.addEventListener('input', function (e) {
    if (
      e.target.matches('input[type="search"][name="q"]') ||
      e.target.matches('input[data-js-search-input]')
    ) {
      rvRenderInSearch();
    }
  });

  document.addEventListener('keyup', function (e) {
    if (
      e.target.matches('input[type="search"][name="q"]') ||
      e.target.matches('input[data-js-search-input]')
    ) {
      rvRenderInSearch();
    }
  });
});